export const dashOrSpaceToUnderscore = <T extends string>(str: T): T =>
  str.replaceAll(/[-\s]/g, '_') as T
